<template>
<div class="grid h100" style="grid-template-columns: auto 1fr auto; grid-template-rows: auto auto" v-loading="loading">


<navbar :hotel="hotel" :settings="settings" :ombrelli="ombrelli" :getOmbrelli="getOmbrelli"></navbar>

<div class="grid toolbox">
  <el-button-group>
    <el-tooltip class="item" v-if="!bulkedit" effect="dark" content="Cambia struttura spiaggia" placement="bottom">
      <el-button type="primary" v-if="!setgrid" @click="setgrid = true" class="btn-primary"><i class="fas fa-th"></i></el-button>
      <el-button type="primary" v-if="setgrid" @click="setgrid = false" class="btn-primary"><i class="fas fa-th"></i></el-button>
    </el-tooltip>
    <el-tooltip class="item" v-if="bulkedit" effect="dark" content="Cambia impostazioni Ombrelloni" placement="bottom">
      <el-button type="primary" @click="show('bulkombrellosettings'), disableSelection()" class="btn-primary"><i class="fas fa-edit"></i></el-button>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" content="Abilita Multi-Edit" placement="bottom">
      <el-button type="primary" @click="enableSelection" v-if="!bulkedit" class="btn-primary"><i class="fas fa-lock"></i></el-button>
      <el-button type="primary" @click="destroySelection()" v-if="bulkedit" class="btn-primary"><i class="fas fa-unlock"></i></el-button>
    </el-tooltip>
  </el-button-group>
</div>

    <!-- <div class="h100 w20"></div> -->
  <div class="test" style="display: grid; justify-items: center; align-content: start; align-content: start; overflow: auto; height: 100vh; padding: 0px;">  

    <!-- <i class="fas fa-cog" @click="show('bulkombrellosettings')"></i> -->
    <!-- <i class="fas fa-cogs" @click="enableSelection"></i> -->

    <div class="grid setgrid" v-if="setgrid">

          <el-form>

          <div v-if="hotel && !loading" class="grid" style="grid-auto-flow: column; grid-column-gap: 24px; justify-content: space-between;">

          <div>
          <label class="el-form-item__label">Righe in Spiaggia</label>
          <el-form-item >
            <el-input-number v-on:change="changeGrid" v-model="hotel.rows" :min="1"  ></el-input-number>
          </el-form-item>
          </div>

          <div>
          <label class="el-form-item__label">Colonne in Spiaggia</label>
          <el-form-item >
            <el-input-number v-on:change="changeGrid" v-model="hotel.cols" :min="1"  ></el-input-number>
          </el-form-item>
          </div>

          <!-- <button type="button" class="btn btn-blue" v-on:click="resetGrid">set grid</button> -->

          </div>

          <div class="grid" style="grid-auto-flow: row;">

          <!-- <div class="spacer xs"></div> -->

         <button type="button" class="btn btn-green" v-on:click="saveGrid">Salve struttura spiaggia</button>


          </div>

          </el-form>

          <!-- {{ombrelli}} -->

    </div>

<div class="boundary">
  
    <div v-cloak class="grid editgrid" :style='gridstyle' v-if="hotel && !loading" style="padding: 96px;">


        <div class="grid ombrello" v-if="!firstreset" v-for="(ombrello, index) in ombrelli">

          <div class="grid seat free" :class="{ nonvisible : !ombrello.visible }" :id="ombrello._id" :data-item="ombrello.ombrid" :data-id="ombrello._id">
            <!-- <a class="blocco nr" :id="ombrello._id">{{ombrello.ombrid}}</a> -->
            <!-- <p>{{ombrello._id}}</p> -->
            <div>
              <!-- <el-input placeholder="Numero Ombrello" v-model="ombrello.ombrid"></el-input> -->
              {{ombrello.ombrid}}
              <!-- <small>{{ombrello.cashable}}</small> -->
            </div>
            
            <div class="options" v-if="!bulkedit">
              <el-checkbox v-if="!ombrello.visible" v-model="ombrello.visible" label="visible"><i class="fas fa-eye-slash"></i></el-checkbox>
              <el-checkbox v-if="ombrello.visible" v-model="ombrello.visible" label="visible"><i class="fas fa-eye"></i></el-checkbox>

              <el-checkbox v-if="!ombrello.cashable && hotel.cashier" v-model="ombrello.cashable" label="cashable"><i class="fab fa-creative-commons-nc-eu"></i></el-checkbox>
              <el-checkbox v-if="ombrello.cashable && hotel.cashier" v-model="ombrello.cashable" label="cashable"><i class="fas fa-euro-sign"></i></el-checkbox>

              <i class="fas fa-cash-register" @click="show('ombrellosettings', ombrello)"></i>

            </div>

          </div>

        </div>

        <div class="grid ombrello" v-if="firstreset" v-for="(ombrello, index) in newombrelli">

          <div class="grid seat free" :id="ombrello._id">
            <!-- <a class="blocco nr" :id="ombrello._id">{{ombrello.ombrid}}</a> -->
            <span>{{ombrello.ombrid}}</span>
            <!-- <el-input placeholder="Numero Ombrello" v-model="ombrello.ombrid"></el-input> -->
            <!-- <i class="fas fa-eye-slash"></i> -->
          </div>

        </div>


    </div>

</div>
    

    </div>

    <modal name="ombrellosettings" v-if="!loading && hotel" width="50%" :minWidth="360" :maxWidth="1040" height="auto" :adaptive="true" scrollable>
      <div class="grid ombrellosettings">
        <div class="grid seasons">
          <h1>{{ombrellos.ombrid}} <span v-for="ombrello in selectedOmbrellos">{{ombrello}}</span></h1>
          <small>{{ombrellos.seasons}}</small>
          <el-form>
            <div class="grid season" v-for="season in hotel.seasons">
              <span>{{season.name}}</span>
              <div class="grid data">
                <span><small>{{season.start}} > {{season.end}}</small></span>
                <i class="fas fa-edit" v-on:click="editseason(season, index)"></i>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </modal>


    <modal name="bulkombrellosettings" v-if="!loading && hotel" width="70%" :minWidth="360" :maxWidth="1040" height="auto" :adaptive="true" scrollable @before-close="beforeClose">
      <div class="grid bulkombrellosettings">
        <span v-if="selectedOmbrellos.length === 0">Nessun Ombrellone selezionato</span>
        <div class="grid selectedombrellos" v-if="selectedOmbrellos.length >= 1">
          <span v-for="ombrello in selectedOmbrellos">{{ombrello.ombrid}}</span>
        </div>
        <el-form>
        <div class="grid seasons">
          <!-- <h1> <span v-for="ombrello in selectedOmbrellos">{{ombrello}}</span></h1> -->
          <span><strong>Cambia impostazioni per tutti gli ombrelloni selezionati</strong></span>
          <div class="spacer sm"></div>
            <div class="grid season" v-for="(season, index) in newseasons">
              <span>{{season.name}}</span>
              <div class="grid data">
                <span><small>{{season.start}} > {{season.end}}</small></span>
                <span><small>€ {{season.amount}}</small></span>
                <i class="fas fa-edit" v-on:click="editseason(season, index)"></i>
              </div>
            </div>
            <!-- <small>{{hotel.seasons}}</small> -->
            <div class="spacer sm"></div>
            <!-- <small>{{newseasons}}</small> -->
          <div class="grid setting" v-if="hotel.cashier">
            <span>Ombrelloni a pagamento</span>
            <el-switch
              v-model="ombrellos.cashable"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </div>
          <div class="grid setting">
            <span>Ombrelloni visibili</span>
            <el-switch
              v-model="ombrellos.visible"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </div>
          <div class="spacer sm"></div>
          <el-button type="button" @click="saveBulk" class="btn btn-green">Salva Impostazioni</el-button>
        </div>
        </el-form>

        <div class="grid addseason" v-if="updateseason">
          <span><strong>Update stagione: {{newseason.name}}</strong></span>
          <!-- <small>{{newseason}}</small> -->

          <div class="spacer sm"></div>

          <el-form>

            <el-form-item label="Prezzo base ombrellone">
                <el-input v-model="newseason.amount" placeholder="Prezzo ombrellone" name="ombrellone">
                  <template slot="prepend">€</template>
                </el-input>
              </el-form-item>
            <div v-for="item in newseason.items">
              <!-- <span v-html="item.icon"></span> -->
              <el-form-item :label="'Prezzo base ' + item.name ">
                <el-input v-model="item.price" placeholder="Prezzo oggetto" name="price">
                  <template slot="prepend">€</template>
                </el-input>
              </el-form-item>
            </div>
            
              <!-- {{hotel.items}} -->
              <div class="spacer sm"></div>
            <el-form-item>
              <div style="float: right;">
                <el-button class="btn btn-green" @click="bulkUpdateseason()">salva impostazioni stagione</el-button>
              </div>
            </el-form-item>

          </el-form>

        </div>

      </div>

    </modal>

  
</div>
</template>

<script>
  // import Vue from 'vue'
  import {Circle4} from 'vue-loading-spinner'
  import datepicker from 'vue-date'
  import {DateRange} from 'vue-date-range'
  import Moment from 'moment'
  import { extendMoment } from 'moment-range'
  import 'moment/locale/de'
  import 'moment/locale/it'
  const moment = extendMoment(Moment)
  import Navbar from '@/components/Navbar'
  import { Drag, Drop } from 'vue-drag-drop'
  import * as Selection from '@simonwep/selection-js'
  import options from '../selectionoptions' // import options for selection.js
  // const selection = Selection.create(options)
  // import EmbeddedSlack from 'embedded-slack'
  // const chat = new EmbeddedSlack({
  //   containerId: 'embedded-slack',
  //   channel: 'C03M1FH6Y',
  //   token: 'xoxp-3715527188-3715527214-346873012933-85307408b261ae33e2a178e9a2c4914c'
  // })
  var host = process.env.ROOT_API
  // var sockethost = process.env.ROOT_SOCKET
  // var host = 'http://drop3.drophost.it:44534'
  export default {
    name: 'ombrelli',
    props: ['auth', 'authenticated'],
    data () {
      return {
        loading: true,
        nogrid: false,
        firstreset: false,
        grid: {
          direction: '',
          letter: true,
          number: true,
          firststep: false,
          active: 0
        },
        state1: '',
        setgrid: false,
        langs: [{
          lang: 'it'
        }, {
          lang: 'de'
        }],
        hotel: '',
        secret: '',
        updateseason: false,
        newseasons: [],
        // pregrid: '',
        newseason: '',
        ombrelli: [],
        newombrelli: [],
        style: '',
        rangestyle: '',
        hotelid: '',
        ombrellos: {
          cashable: true,
          visible: true
        },
        addombrello: {
          ombrid: ''
        },
        bulkedit: false,
        overview: {
          arrivals: [],
          departures: []
        },
        date: ['2016-10-16', '2024-10-05'],
        today: moment().format('YYYY-MM-DD'),
        lang: 'it',
        range: {
          startDate: moment(),
          endDate: moment().add(7, 'days')
          // startDate: '2019-04-03',
          // endDate: '2019-04-10'
        },
        rangepicker: [],
        rangeviewdata: '',
        // disabledRange: {
        //   startDate: moment(),
        //   endDate: moment().add(9, 'days')
        // },
        disabledDates: [],
        datePickerOptions: {
          firstDayOfWeek: 1
        },
        firstDayOfWeek: 1,
        editombrid: false,
        dragging: null,
        lock: null,
        location: 'beach',
        alphabet: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
        letters: {
          first: 'A',
          last: '',
          act: 0,
          row: 1
        },
        numbers: {
          first: 1,
          last: 0,
          act: 0
        },
        selectedOmbrellos: [],
        rules: {
          name: [
              { required: true, message: 'prego inserisci un nome per la stagione', trigger: 'blur' }
          ]
        }
      }
    },
    components: {
      datepicker,
      Circle4,
      DateRange,
      'Navbar': Navbar,
      Drag,
      Drop
      // EmbeddedSlack
      // chat
    },
    sockets: {
      connect: function () {
        console.log('socket connected')
      },
      stream: function (val) {
        // console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
        // console.log(val.hotelid)
        if (val.hotelid === this.hotelid) {
          console.log('an umbrella was updated')
          this.getOmbrelli()
        }
      },
      disconnect: function () {
        console.log('socket error')
        // this.$notify({
        //   group: 'foo',
        //   title: 'Error loading Data',
        //   text: 'I´ll fix it in a few',
        //   type: 'warning',
        //   duration: 5000
        // })
      }
    },
    methods: {
      editseason (season, index) {
        this.updateseason = true
        this.newseason = season
        console.log(season)
      },
      enableSelection () {
        this.selection = Selection.create(options)
        this.newseasons = []
        // Selection.create(options)
        // selection()
        this.bulkedit = true
        // this.newseasons = this.hotel.seasons
        // this.newseasons = Object.assign(this.hotel.seasons, true)
        this.newseasons = JSON.parse(JSON.stringify(this.hotel.seasons))
        // this.newseasons = Array.from(this.hotel.seasons).map(m => m)
        // this.newseasons = Array.from(this.hotel.seasons)
        // this.newseasons = this.hotel.seasons.slice(0)
        // this.hotel.seasons.forEach((season, index) => {
        //   console.log(index, season)
        //   this.newseasons.push(Vue.util.extend({}, season))
        //   // this.newseasons[index] = season
        //   // Vue.set(this.newseasons[index], {}, season)
        // })
        this.$notify.success({
          title: 'Multiedit abilitato',
          message: 'Adesso puoi selezionare multipli ombrelloni con il tuo mouse, cosi come lo fai gia sul tuo device.',
          offset: 100
        })
        // console.log(this.newseasons)
      },
      disableSelection () {
        this.selection.disable()
      },
      destroySelection () {
        var items = this.$el.querySelectorAll('.selected')
        items.forEach((guest, indexo) => {
          guest.classList.remove('selected')
        })
        this.selection.clearSelection()
        this.selection.destroy()
        this.bulkedit = false
      },
      beforeClose () {
        this.selection.enable()
        this.newseason = ''
        this.updateseason = false
      },
      getelements () {
        this.selectedOmbrellos = []
        // console.log(this.$el.querySelectorAll('.selected'))
        var items = this.$el.querySelectorAll('.selected')
        items.forEach((guest, indexo) => {
          // console.log(guest.dataset.item, guest.dataset.id)
          this.selectedOmbrellos.push({ombrid: guest.dataset.item, id: guest.dataset.id})
        })
      },
      changeGrid () {
        this.resetGrid()
        this.firstreset = true
      },
      resetGrid () {
        console.log('resetGrid')
        // this.ombrelli = []
        var first = this.ombrelli[0].ombrid.match(/[a-zA-Z]+|[0-9]+/g)
        console.log(first)
        this.letters.first = first[0]
        this.numbers.first = first[1]
        this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase())
        this.letters.row = 1
        this.numbers.act = this.numbers.first
        if (this.letters.first.length === 0 || this.hotel.gridtype === 'empty') {
          this.newombrelli = []
          this.numbers.first = first[0]
          this.numbers.act = first[0]
          this.setemptyGrid()
        } else {
          this.newombrelli = []
          this.setGrid()
        }
      },
      setemptyGrid () {
        var grid = this.hotel.cols * this.hotel.rows
        // this.hotel.gridtype = 'empty'
        console.log('newombrelli length', (this.newombrelli.length + 1), 'numbers act: ', this.numbers.act)
        if (this.newombrelli.length === grid) {
          console.log('done')
          this.compareGrid()
        } else {
          this.newombrelli.push({ombrid: (parseInt(this.numbers.act)), free: true})
          this.numbers.act++
          this.setemptyGrid()
        }
      },
      compareGrid () {
        console.log('compare now')
        // this.ombrelli.filter(post => {
        //   this.newombrelli.filter(newpost => {
        //     if (post.ombrid.includes(newpost.ombrid)) {
        //       console.log(post.ombrid + ' already there')
        //     } else {
        //       // this.newombrelli.push({ombrid: act + this.numbers.act, free: true})
        //     }
        //   })
        // })
        if (this.hotel.gridtype === 'empty') {
          this.newombrelli.forEach((ombrello, indexo) => {
            this.ombrelli.forEach((ombrella, index) => {
              if (ombrello.ombrid.toString() === ombrella.ombrid) {
                console.log(ombrella.ombrid + ' already there: ', indexo)
                this.newombrelli[indexo] = ombrella
              } else {
                // console.log(ombrella.ombrid + ' is a new one')
              }
            })
          })
        } else {
          this.newombrelli.forEach((ombrello, indexo) => {
            this.ombrelli.forEach((ombrella, index) => {
              if (ombrello.ombrid === ombrella.ombrid) {
                console.log(ombrella.ombrid + ' already there: ', indexo)
                this.newombrelli[indexo] = ombrella
              } else {
                // console.log(ombrella.ombrid + ' is a new one')
              }
            })
          })
        }
      },
      setGrid () {
        var grid = this.hotel.cols * this.hotel.rows
        // console.log(this.letters.first)
        console.log(grid)
        if (this.letters.act === this.alphabet.length) {
          this.letters.act = 0
        }
        var act = this.alphabet[this.letters.act].toUpperCase()
        // console.log('act: ', act, this.numbers.act)
        if (this.newombrelli.length === grid) {
          console.log('done')
          this.compareGrid()
        } else {
          // console.log('not done')
          // this.ombrelli.filter(post => {
          //   // var stays = post.ombrid.toLowerCase().includes((act + this.numbers.act).toLowerCase())
          //   // console.log((act + this.numbers.act), post.ombrid.toLowerCase().includes((act + this.numbers.act).toLowerCase()))
          //   if (post.ombrid.includes((act + this.numbers.act))) {
          //     console.log((act + this.numbers.act) + ' already there')
          //     this.newombrelli.push(post)
          //   } else {
          //     // this.newombrelli.push({ombrid: act + this.numbers.act, free: true})
          //   }
          // })
          // this.ombrelli.find(function (omg) {
          //   console.log(omg === (act + this.numbers.act))
          // })
          // this.ombrelli.forEach((ombrello, indexo) => {
          //   if (ombrello.ombrid === (act + this.numbers.act)) {
          //     console.log((act + this.numbers.act) + ' already there')
          //     this.newombrelli.push(ombrello)
          //   } else {
          //     // this.newombrelli.push({ombrid: act + this.numbers.act, free: true})
          //   }
          // })
          this.newombrelli.push({ombrid: act + this.numbers.act, free: true})
          // console.log('nr: ', act + this.numbers.act)
          if (this.hotel.gridtype === 'left') {
            this.numbers.act++
          } else {
            this.letters.act++
          }
          if (this.newombrelli.length === (this.hotel.cols * this.letters.row)) {
            if (this.hotel.gridtype === 'left') {
              this.numbers.act = this.numbers.first
              this.letters.row++
              this.letters.act++
            } else {
              this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase())
              this.numbers.act++
              this.letters.row++
            }
            console.log('end of row', this.letters.row - 1, this.numbers.act)
          } else {}
          this.setGrid()
        }
      },
      show (modal, ombrello) {
        this.getelements()
        console.log(this.selectedOmbrellos.length)
        if (this.selectedOmbrellos.length === 0) {
          this.ombrellos = ombrello
        } else {}
        this.$modal.show(modal)
      },
      hide (modal) {
        this.$modal.hide(modal)
      },
      settings () {
        this.$modal.show('settings')
      },
      saveBulk () {
        console.log(this.ombrellos)
        console.log(this.selectedOmbrellos)
        this.$http
          .post(host + '/api/savebulkombrelloni', { ombrellos: this.ombrellos, selectedOmbrellos: this.selectedOmbrellos },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            this.$modal.hide('bulkombrellosettings')
            this.getOmbrelli()
            this.$notify.success({
              title: this.selectedOmbrellos.length + ' Ombrelloni salvati',
              offset: 100
            })
          }, (error) => {
            console.log(error)
            this.$notify.error({
              title: 'Si é verificato un errore, prego riprovare',
              offset: 100
            })
          })
      },
      bulkUpdateseason () {
        console.log(this.ombrellos)
        console.log(this.selectedOmbrellos)
        console.log(this.hotel.seasons)
        console.log(this.newseasons)
        this.$http
          .post(host + '/api/bulkupdateseason', { oldseasons: this.hotel.seasons, newseasons: this.newseasons, selectedOmbrellos: this.selectedOmbrellos },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            this.$modal.hide('bulkombrellosettings')
            this.getOmbrelli()
            this.newseason = ''
            this.updateseason = false
            this.$notify.success({
              title: this.selectedOmbrellos.length + ' Ombrelloni salvati',
              offset: 100
            })
          }, (error) => {
            console.log(error)
            this.$notify.error({
              title: 'Si é verificato un errore, prego riprovare',
              offset: 100
            })
          })
      },
      saveGrid: function () {
        // console.log(this.ombrelli)
        this.loading = true
        if (this.newombrelli.length > 0) {
          console.log('new ombrelli')
          this.$http
            .post(host + '/api/resetgrid', { hotel: this.hotel, ombrelli: this.newombrelli },
            {
              headers: {
                'Authorization': 'Bearer ' + localStorage.jwt
              }
            },
            ).then((data) => {
              console.log(data)
              this.firstreset = false
              this.newombrelli = []
              this.getOmbrelli()
              this.loading = false
              this.nogrid = false
            }, (error) => {
              console.log(error)
              this.$notify.error({
                title: 'Si é verificato un errore, prego riprovare',
                offset: 100
              })
            })
        } else {
          console.log('old ombrelli')
          this.$http
            .post(host + '/api/resetgrid', { hotel: this.hotel, ombrelli: this.ombrelli },
            {
              headers: {
                'Authorization': 'Bearer ' + localStorage.jwt
              }
            },
            ).then((data) => {
              console.log(data)
              this.firstreset = false
              this.ombrelli = []
              this.getOmbrelli()
              this.loading = false
              this.nogrid = false
            }, (error) => {
              console.log(error)
              this.$notify.error({
                title: 'Si é verificato un errore, prego riprovare',
                offset: 100
              })
            })
        }
      },
      getOmbrelli () {
        this.$http
          .post(host + '/ombrelloni/all', { hotelid: this.$route.params.hotel },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log('hotel: ', data.body.ombrells)
            this.hotelid = data.body.hotels._id
            this.hotel = data.body.hotels
            moment.locale(data.body.hotels.lang)
            if (data.body.hotels.chairs === undefined) {
              this.hotel.chairs = 1
            }
            if (data.body.hotels.beds === undefined) {
              this.hotel.beds = 1
            }
            this.style = 'grid-template-columns: repeat(' + data.body.hotels.cols + ', 1fr); grid-template-rows: repeat(' + data.body.hotels.rows + ', auto);'
            // console.log('hotel: ' + this.hotelid)
            // console.log(data)
            this.ombrelli = data.body.ombrells
            // console.log(this.today)
            if (!this.hotel.firststep && data.body.ombrells <= 0) {
              this.nogrid = true
              // this.setGrid()
            }
            this.loading = false
            // this.$notify.error({
            //   title: 'Si é verificato un errore, prego riprovare',
            //   offset: 100
            // })
          }, (error) => {
            console.log(error)
            this.$router.replace('/')
          })
      }
      // getOverview () {
      //   this.overview.arrivals = []
      //   this.overview.departures = []
      //   this.ombrelli.forEach((ombrello, indexo) => {
      //     // console.log('ombrello: ', ombrello)
      //     // this.ombrelli.push(ombrello)
      //     ombrello.guests.forEach((guest, index) => {
      //       console.log('guest: ', guest)
      //       // console.log(moment(this.today).isBetween(guest.arrival, guest.departure))
      //       if (moment(this.today).isSame(guest.arrival)) {
      //       // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
      //         console.log(ombrello.ombrid + ' is coming today: ' + guest.arrival)
      //         this.overview.arrivals.push({guest: guest, ombrid: ombrello.ombrid})
      //       } else {
      //         // console.log(ombrello.ombrid + ' is free on ' + this.today)
      //         // this.ombrelli[indexo].free = true
      //       }
      //       if (moment(this.today).isSame(guest.departure)) {
      //       // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
      //         console.log(ombrello.ombrid + ' is starting today: ' + guest.departure)
      //         this.overview.departures.push({guest: guest, ombrid: ombrello.ombrid})
      //       } else {
      //         // console.log(ombrello.ombrid + ' is free on ' + this.today)
      //         // this.ombrelli[indexo].free = true
      //       }
      //     })
      //   })
      // },
      // addchair (index, nr, chair, hotel) {
      //   console.log(this.ombrelli)
      //   console.log(index, chair, hotel)
      //   var newchairs = nr + 1
      //   this.$http
      //     .post(host + '/api/addchair/' + chair, {chairid: chair, hotelid: hotel},
      //     {
      //       headers: {
      //         'Authorization': 'Bearer ' + localStorage.jwt
      //       }
      //     },
      //     ).then((data) => {
      //       console.log(data)
      //       // this.loading = false
      //       Vue.set(this.ombrelli[index], 'chairs', newchairs)
      //       // this.$notify({
      //       //   group: 'foo',
      //       //   title: 'Chair added',
      //       //   type: 'success',
      //       //   duration: 500
      //       // })
      //     }, (error) => {
      //       console.log(error)
      //     })
      // },
      // removechair (index, nr, chair, hotel) {
      //   console.log(this.ombrelli)
      //   console.log(index, chair, hotel)
      //   var newchairs = nr - 1
      //   this.$http
      //     .post(host + '/api/removechair/' + chair, {chairid: chair, hotelid: hotel},
      //     {
      //       headers: {
      //         'Authorization': 'Bearer ' + localStorage.jwt
      //       }
      //     },
      //     ).then((data) => {
      //       console.log(data)
      //       // this.loading = false
      //       Vue.set(this.ombrelli[index], 'chairs', newchairs)
      //     }, (error) => {
      //       console.log(error)
      //     })
      // },
      // addbed (index, nr, chair, hotel) {
      //   console.log(this.ombrelli)
      //   console.log(index, chair, hotel)
      //   var newchairs = nr + 1
      //   this.$http
      //     .post(host + '/api/addbed/' + chair, {chairid: chair, hotelid: hotel},
      //     {
      //       headers: {
      //         'Authorization': 'Bearer ' + localStorage.jwt
      //       }
      //     },
      //     ).then((data) => {
      //       console.log(data)
      //       // this.loading = false
      //       Vue.set(this.ombrelli[index], 'beds', newchairs)
      //     }, (error) => {
      //       console.log(error)
      //     })
      // },
      // removebed (index, nr, chair, hotel) {
      //   console.log(this.ombrelli)
      //   console.log(index, chair, hotel)
      //   var newchairs = nr - 1
      //   this.$http
      //     .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
      //     {
      //       headers: {
      //         'Authorization': 'Bearer ' + localStorage.jwt
      //       }
      //     },
      //     ).then((data) => {
      //       console.log(data)
      //       // this.loading = false
      //       Vue.set(this.ombrelli[index], 'beds', newchairs)
      //     }, (error) => {
      //       console.log(error)
      //     })
      // }
    },
    beforeMount () {
      this.getOmbrelli()
      // this.letters.act = this.alphabet.indexOf(this.letters.first)
    },
    mounted: function () {
      // Selection.create(options)
      // this.getOverview()
      // moment.locale(this.hotel.lang)
      // console.log('hotel: ', this.hotel)
    },
    beforeDestroy () {
      this.selection.destroy()
    },
    computed: {
      // newseasons: {
      //   get () {
      //     // console.log(this.range)
      //     return Object.assign({}, this.hotel.seasons)
      //     // return [moment(this.range.startDate).format('YYYY-MM-DD'), moment(this.range.endDate).format('YYYY-MM-DD')]
      //   },
      //   set (newValue) {
      //     console.log(newValue)
      //   }
      // },
      hotelgrid: function () {
      // `this` points to the vm instance
        this.numbers.last = this.hotel.cols * this.hotel.rows
        return this.hotel.cols * this.hotel.rows
      },
      gridstyle () {
        return 'grid-template-columns: repeat(' + this.hotel.cols + ', 1fr); grid-template-rows: repeat(' + this.hotel.rows + ', auto);'
      }
    }
  }
</script>

<style>
  
</style>




// WEBPACK FOOTER //
// Editgrid.vue?3fecbd2c